'use client';

import { ArrowLeft, ArrowRight } from 'lucide-react';
import { type JSX, useState } from 'react';

export function PageableGrid({
  children,
  t,
}: {
  children: JSX.Element[];
  t: { nextPage: string; prevPage: string };
}) {
  const [page, setPage] = useState(1);
  const itemsPerPage = 4;
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedItems = children.slice(startIndex, endIndex);

  const totalPages = Math.ceil(children.length / itemsPerPage);

  function handleNextPage() {
    setPage((prevPage) => prevPage + 1);
  }

  function handlePrevPage() {
    setPage((prevPage) => prevPage - 1);
  }

  return (
    <div>
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2">{displayedItems}</div>
      <div className="mt-16 flex justify-between">
        <div className="flex w-min gap-2">
          <button
            onClick={handlePrevPage}
            disabled={page === 1}
            className="btn btn-square btn-outline btn-primary text-primary"
          >
            <ArrowLeft />
          </button>
          <span className="flex items-center p-1 text-[10px] font-medium uppercase">
            {t.prevPage}
          </span>
        </div>
        <div className="flex w-min gap-2">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
            <button
              key={pageNumber}
              onClick={() => setPage(pageNumber)}
              className={`btn hidden border-transparent md:block ${
                pageNumber === page ? 'btn-primary text-white' : 'bg-inherit'
              }`}
            >
              {pageNumber}
            </button>
          ))}
          <span className="flex items-center p-1 text-[10px] font-medium uppercase">
            {t.nextPage}
          </span>
          <button
            onClick={handleNextPage}
            disabled={page === totalPages}
            className="btn btn-square btn-outline btn-primary text-primary"
          >
            <ArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
}
